/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_No_Tags_FoundInputs */

const en_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tags found`)
};

const fr_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun tag trouve`)
};

const de_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Tags gefunden`)
};

const it_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun tag trovato`)
};

const ru_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги не найдены`)
};

const es_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron etiquetas`)
};

const zh_cn2_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到标签`)
};

const ja_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグが見つかりません`)
};

const hi_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई टैग नहीं मिला`)
};

const pt_pt2_tags_no_tags_found = /** @type {(inputs: Tags_No_Tags_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma etiqueta encontrada`)
};

/**
* | output |
* | --- |
* | "No tags found" |
*
* @param {Tags_No_Tags_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_no_tags_found = /** @type {((inputs?: Tags_No_Tags_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_No_Tags_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_no_tags_found(inputs)
	if (locale === "de") return de_tags_no_tags_found(inputs)
	if (locale === "it") return it_tags_no_tags_found(inputs)
	if (locale === "ru") return ru_tags_no_tags_found(inputs)
	if (locale === "es") return es_tags_no_tags_found(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_no_tags_found(inputs)
	if (locale === "ja") return ja_tags_no_tags_found(inputs)
	if (locale === "hi") return hi_tags_no_tags_found(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_no_tags_found(inputs)
	return en_tags_no_tags_found(inputs)
});